export default __webpack_public_path__ + "media/images/zoom_v2-2fe9c80a1d0cb25b0aaabaf019ef5994.png";